// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__1iMkh","title":"style_title__EuFFB","subTitle":"style_subTitle__GkyUf","aboutBtn":"style_aboutBtn__oKSeJ","scrollIcon":"style_scrollIcon__dCMpu"};